import { InputText } from "primereact/inputtext";

// Format date and time from timestamp
export const formatDate = (timestamp: number) => {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp * 1000);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const EnvSignaturesInPermit = ({
  teamMember1,
  teamMember2,
  additionalTeamMembers,
  currentFormValues,
  signatureDataURLs,
  envEntrantTopmans,
  setEnvEntrantTopmans,
  type,
}: any) => {
  return (
    <>
      <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 sm:tw-gap-6 tw-w-full">
        {teamMember1?.userID && (
          <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
            <div className="tw-flex tw-items-center tw-gap-2 tw-justify-between tw-w-full">
              <p className="leak-detail-label tw-text-black tw-max-w-[60%] tw-truncate">
                {teamMember1?.displayName || "Unknown User"}
              </p>
              <p className="tw-text-sm">{formatDate(currentFormValues.date)}</p>
            </div>
            <img
              src={signatureDataURLs.firstRef}
              alt={`${teamMember1?.displayName || "User"} signature`}
              className="tw-w-full tw-max-h-32 tw-shrink-0 tw-object-contain tw-border"
            />
            {/* <p className="leak-detail-label tw-text-black tw-truncate tw-w-full">
                          {teamMember1?.displayName || "Unknown User"}
                        </p> */}
            {
              <InputText
                type="text"
                value={envEntrantTopmans?.teamMember1[type] ?? ""}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setEnvEntrantTopmans((prev: any) => ({
                    ...prev,
                    teamMember1: {
                      ...prev.teamMember1,
                      [type]: newValue,
                    },
                  }));
                }}
                className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                placeholder="Entrant/Topman "
              />
            }
          </div>
        )}
        {teamMember2?.userID && (
          <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
            <div className="tw-flex tw-items-center tw-gap-2 tw-justify-between tw-w-full">
              <p className="leak-detail-label tw-text-black tw-max-w-[60%] tw-truncate">
                {teamMember2?.displayName || "Unknown User"}
              </p>
              <p className="tw-text-sm">{formatDate(currentFormValues.date)}</p>
            </div>
            <img
              src={signatureDataURLs.secondRef}
              alt={`${teamMember2?.displayName || "User"} signature`}
              className="tw-w-full tw-max-h-32 tw-shrink-0 tw-object-contain tw-border"
            />
            {/* <p className="leak-detail-label tw-text-black tw-truncate tw-w-full">
                          {teamMember2?.displayName || "Unknown User"}
                        </p> */}
            {
              <InputText
                type="text"
                value={envEntrantTopmans?.teamMember2[type] ?? ""}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setEnvEntrantTopmans((prev: any) => ({
                    ...prev,
                    teamMember2: {
                      ...prev.teamMember2,
                      [type]: newValue,
                    },
                  }));
                }}
                className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                placeholder="Entrant/Topman "
              />
            }
          </div>
        )}
        {additionalTeamMembers.length > 0 &&
          additionalTeamMembers?.map((user: any, index: number) => {
            return (
              <div
                key={index}
                className="tw-flex tw-flex-col tw-items-start tw-gap-1"
              >
                <div className="tw-flex tw-items-center tw-gap-2 tw-justify-between tw-w-full">
                  <p className="leak-detail-label tw-text-black tw-max-w-[60%] tw-truncate">
                    {user?.displayName || "Unknown User"}
                  </p>
                  <p className="tw-text-sm">
                    {formatDate(currentFormValues.date)}
                  </p>
                </div>
                <img
                  src={signatureDataURLs.additionalRefs[index]}
                  alt={`${user?.displayName || "User"} signature`}
                  className="tw-w-full tw-max-h-32 tw-shrink-0 tw-object-contain tw-border"
                />
                <InputText
                  type="text"
                  value={
                    envEntrantTopmans?.additionalMembers[type]?.find(
                      (member: any) => member.userID === user?.userID
                    )?.value ?? ""
                  }
                  onChange={(e) => {
                    const newValue = e.target.value;
                    setEnvEntrantTopmans((prev: any) => {
                      const existing = prev.additionalMembers[type] ?? [];
                      const userID = user?.userID;
                      const alreadyExists = existing.some(
                        (item: any) => item.userID === userID
                      );
                      let newPermitApproval;
                      if (alreadyExists) {
                        newPermitApproval = existing.map((item: any) =>
                          item.userID === userID
                            ? { ...item, value: newValue }
                            : item
                        );
                      } else {
                        newPermitApproval = [
                          ...existing,
                          {
                            userID: userID,
                            value: newValue,
                          },
                        ];
                      }
                      return {
                        ...prev,
                        additionalMembers: {
                          ...prev.additionalMembers,
                          [type]: newPermitApproval,
                        },
                      };
                    });
                  }}
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  placeholder="Entrant/Topman "
                />
              </div>
            );
          })}
      </div>
    </>
  );
};

export default EnvSignaturesInPermit;
